import React, { useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getSchools } from '../../actions/schoolsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { Link } from 'react-router-dom'


export default function Schools() {
    const { t } = useTranslation()
    const {client} = useAuth()
	const dispatch = useDispatch()
	const {schools} = useSelector(state=>state.schools)

	useEffect(() => {
		if(client){
			dispatch(getSchools())
		}
	},[dispatch, t, client])

	const columnsSchools = [
		{
			name: t('admin.dashboard.name'),
			cell: school =>
				<>
					<div className='text-center'>
						{school.image
							?
								<img className="img-profile-small me-3" alt="Preview" src={typeof school.image === 'string' ? school.image : URL.createObjectURL(school.image)} style={{width: "50px"}} />
							:
								<i className="fas fa-user fa-2x img-profile-small me-3"></i>
						}
					</div>
					<div className='text-left'>
						{school.name} ({school.code})
					</div>
				</>,
			selector: (school) => school.name,
			sortable: true,
		},{
			name: t('global.actions'),
			cell: school =>
				<div>
					<Link to={`/admin/schoolprofile/${school.iduser}`}>
						<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
					</Link>
					<Link to={`/admin/activeprocesses/${school.id}`}>
						<img src="/images/menus/processes.svg" alt="Icono Procesos" className='me-3' />
					</Link>
				</div>,
			selector: (school) => school.marketing,
			sortable: true,
		}
	]

	return (
		<>
			<Container className='cuerpo'>
				<Row>
					<h1>{t('admin.dashboard.schools')}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
								<div className='d-flex justify-content-end'>
									<Link to="/admin/schools/new" className='btn btn-primary'><i className='fas fa-plus me-2'/>{t("admin.dashboard.createSchool")}</Link>
								</div>
								{schools?.length > 0
									?
										<CustomDataTable columns={columnsSchools} data={schools} />
									:
										<>{t('admin.dashboard.thereisnotschools')}</>
								}
							</Card.Body>

						</Card>
					</Col>
				</Row>
			</Container>
        </>
    )
}